/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-03-23 16:21:33
 * @LastEditors: Jack Deng
 * @LastEditTime: 2022-07-19 16:59:02
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelContentEditor/SalesChannelEditorShoppingCartPage/EmptyStateSetting/index.tsx
 */
import React from 'react';

//import css from './css.less';

import _ from 'lodash';

import { Uploader } from '@/src/components';
import { Input } from '@/src/components/Antd';
import { useSingleImageEffect } from '@/src/components/Upload';
import ItemWrapper from '@/src/constrains/SalesChannelPreviewPageComponents/OverwriteItemWrapper';
import Section from '@/src/constrains/SalesChannelPreviewPageComponents/SectionContainer';
import { getI18nFromGeneral } from '@/src/tools/tools';
import { useDispatch } from 'react-redux';
import ColorPicker from 'src/components/ColorPicker/ColorPicker';
import ErrorProcessingHOC from 'src/constrains/SalesChannelPreviewPageComponents/ErrorProcessingHOC';
import { useI18n } from 'src/hooks/useRouterChange';
import { resetConfig } from 'src/pages/SalesChannelContentEditor/SalesChannelEditorShoppingCartPage/common';
import {
  errKey,
  validateEmptyStateSetting,
} from 'src/pages/SalesChannelContentEditor/SalesChannelEditorShoppingCartPage/tools';
import { store } from 'src/store';
import { i18nGet } from 'src/tools/tools';
import {
  EnumCollapseId,
  getCollapseOpenStatus,
  getCollapseValidationMsgDisplay,
  //fetchContentShoppingCartResetConfig,
  getEmptyStateSetting,
  getSubmitStamp,
  onCollapseOpen,
  onEmptyStateSetting,
  onErrorChange,
} from '../slice';
import styles from './css.less';

const EmptyStateSetting = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { isPrimary, data, specificError, withoutCollapse } = props;
  const imageErr = specificError[errKey.emptyStateSettingImageErr];
  const textErr = specificError[errKey.emptyStateSettingTextErr];
  const _d = useDispatch();

  const { image, text, background } = data || {};

  const [fileList, setFileList] = React.useState(image ? [image] : []);
  useSingleImageEffect(image, fileList, setFileList);

  const handleOnImageChange = (img) => {
    _d(onEmptyStateSetting({ image: img }));
  };

  const handleOnTextChange = (text) => {
    _d(onEmptyStateSetting({ text }));
  };

  const handleOnBackgroundChange = (background) => {
    _d(onEmptyStateSetting({ background }));
  };

  return (
    <Section>
      <div className={withoutCollapse ? styles.fieldSection1 : ''}>
        <ItemWrapper
          error={(imageErr || []).length > 0}
          errorText={(imageErr || []).join(' ')}
          title={getI18n('general.hOCTitle.emptyStateImage')}
          bottomTitle={getI18n(
            'salesChannelContent.index.tiprecommendedsizeratio',
          )}>
          <Uploader
            multiple={false}
            width={withoutCollapse ? 312 : '100%'}
            height={180}
            fileList={fileList}
            onChange={(imgArr = []) => {
              setFileList(imgArr);
              const _l = _.last(imgArr);
              handleOnImageChange(_l);
            }}
          />
        </ItemWrapper>
      </div>

      <div className={withoutCollapse ? styles.fieldSection2 : ''}>
        <ItemWrapper title={getI18n('general.responsiveText')}>
          <Input
            error={(textErr || []).length > 0}
            help={(textErr || []).join(' ')}
            size={'large'}
            value={text}
            onChange={handleOnTextChange}
          />
        </ItemWrapper>
        {isPrimary && (
          <ItemWrapper title={getI18n('general.backgroundColour')}>
            <ColorPicker
              onChange={handleOnBackgroundChange}
              color={background}
              multi
            />
          </ItemWrapper>
        )}
      </div>
    </Section>
  );
};
//export default EmptyStateSetting;
export default ErrorProcessingHOC(EmptyStateSetting, {
  getCollapseOpenStatus,
  onCollapseOpen,
  id: EnumCollapseId.emptyStateSetting,
  getContent: getEmptyStateSetting,
  title: getI18nFromGeneral('general.hOCTitle.emptyStateImage'),
  getErrorDisplay: getCollapseValidationMsgDisplay,
  onErrorChange,
  validation: (x, validationProps) => {
    const { isPrimary } = validationProps || {};

    return validateEmptyStateSetting(x, !isPrimary);
  },
  getSubmitStamp,
  headerProps: {
    dotsFunction: [
      {
        onClick: () => {
          resetConfig({
            dispatch: store.dispatch,
            //  defaultState: _defaultEmptyStateSetting,

            key: 'emptyStateSetting',
            // cb: () => {
            //   _d(onEmptyStateSetting(_defaultEmptyStateSetting || {}));
            // },
          });
        },
        key: 'Reset',
        body: getI18nFromGeneral('general.hOCTitle.reset'),
        isDangerous: true,
      },
    ],
    hasDots: true,
    hideDotsWhenNotPrimary: true,
  },
});
